import SimpleLightbox from "simplelightbox";
const initSimpleLightbox = () => {
  if(document.querySelector('.km_title-text-images-logos')){
    new SimpleLightbox('.km_simple-lightbox .km_lightbox--link', {
      captions: false,
      showCounter: false,
      uniqueImages: false
    });
  }
};
export default initSimpleLightbox;





